import React from 'react';
import { useTranslate, useGetIdentity } from 'react-admin';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import CheckIcon from '@mui/icons-material/Check';
import { green, grey } from '@mui/material/colors';

import time_entries from '../../time_entries';
import weeklies from '../../weeklies';
import leaves from '../../leaves';
import suggestions from '../../suggestions';

const textSx = {
    color: grey[400],
    textDecoration: 'line-through'
};

const QuestsTab = ({ quests }) => {
    const { data: account } = useGetIdentity();
    const translate = useTranslate();

    return (
        <Card sx={{ mt: 2 }}>
            <CardContent>
                <List>
                    <ListItemButton component={Link} to="/time_entries/create">
                        <ListItemAvatar>
                            <Avatar sx={{ backgroundColor: quests?.warningTimesheet ? grey[400] : green[200] }}>
                                {quests?.warningTimesheet ? (
                                    <time_entries.icon />
                                ) : (
                                    <CheckIcon />
                                )}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={translate('Fill in my timesheet')}
                            sx={quests?.warningTimesheet ? {} : textSx}
                        />
                    </ListItemButton>
                    <ListItemButton component={Link} to="/weeklies/create">
                        <ListItemAvatar>
                            <Avatar sx={{ backgroundColor: quests?.warningWeekly ? grey[400] : green[200] }}>
                                {quests?.warningWeekly ? (
                                    <weeklies.icon />
                                ) : (
                                    <CheckIcon />
                                )}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={translate('Create my weekly')}
                            sx={quests?.warningWeekly ? {} : textSx}
                        />
                    </ListItemButton>
                    {quests?.warningLeaves && (
                        <ListItemButton component={Link} to="/leaves">
                            <ListItemAvatar>
                                <Avatar sx={{ backgroundColor: quests?.warningLeaves ? grey[400] : green[200] }}>
                                    {quests?.warningLeaves ? (
                                        <leaves.icon />
                                    ) : (
                                        <CheckIcon />
                                    )}
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={translate('Check that my leaves have been filled correctly')}
                                sx={quests?.warningLeaves ? {} : textSx}
                            />
                        </ListItemButton>
                    )}
                    <ListItemButton component={Link} to={`/suggestions?filter={"status":"new", "unvoted_by":${account?.id}}`}>
                        <ListItemAvatar>
                            <Avatar sx={{ backgroundColor: quests?.warningSuggestions ? grey[400] : green[200] }}>
                                {quests?.warningSuggestions ? (
                                    <suggestions.icon />
                                ) : (
                                    <CheckIcon />
                                )}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={translate('Vote for %{count} suggestions', { count: quests?.suggestionCount || 0 })}
                            sx={quests?.warningSuggestions ? {} : textSx}
                        />
                    </ListItemButton>
                </List>
            </CardContent>
        </Card>
    );
};

export default QuestsTab;